export var SpotlightTableColumns;
(function (SpotlightTableColumns) {
    // These must match the keys of CatalogField type
    SpotlightTableColumns["METRIC"] = "label";
    SpotlightTableColumns["TABLE"] = "tableLabel";
    SpotlightTableColumns["DESCRIPTION"] = "description";
    SpotlightTableColumns["CATEGORIES"] = "categories";
    SpotlightTableColumns["CHART_USAGE"] = "chartUsage";
    SpotlightTableColumns["OWNER"] = "owner";
})(SpotlightTableColumns || (SpotlightTableColumns = {}));
export const DEFAULT_SPOTLIGHT_TABLE_COLUMN_CONFIG = [
    { column: SpotlightTableColumns.METRIC, isVisible: true },
    { column: SpotlightTableColumns.TABLE, isVisible: false },
    { column: SpotlightTableColumns.DESCRIPTION, isVisible: true },
    { column: SpotlightTableColumns.CATEGORIES, isVisible: true },
    { column: SpotlightTableColumns.CHART_USAGE, isVisible: true },
    { column: SpotlightTableColumns.OWNER, isVisible: false },
];
//# sourceMappingURL=spotlightTableConfig.js.map